// extracted by mini-css-extract-plugin
export default {"list":"list_list__aVtaF","label":"list_label__fmhfR","cancel":"list_cancel__XBYit"};